import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const StnViewSingle = () => {
   useAuthRedirect();
    const {prNo} = useParams();
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const [showLifeDetail, setShowLifeDetail] = useState(false);


 const [loading, setLoading] = useState(true); // ✅ loading state

useEffect(() => {
  const fetchIndentDetails = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/purchaseReq_diApproveReportViewPage?prNo=${prNo}`
      );
      if (response.data && response.data.headerDetails?.length > 0) {
        const items = response.data.headerDetails;

        const storeReqHeader = {
          fld_dept: items[0].fld_dept,
          fld_inref: items[0].fld_inref,
          fld_hod: items[0].fld_hod,
          fld_headmet: items[0].fld_headmet,
          fld_purnumber: items[0].fld_purnumber,
          fld_now: items[0].fld_now,
        };

        setHeader(storeReqHeader);
        setData(response.data.headerDetails);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchIndentDetails();
}, [prNo]);


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                                                            <h2 className="add-txt">Purchase Requisition Dis Approval - Report</h2>
                                                            <Link to='/inventory/purchasesreqdisapproved'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                                            </div>
          
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Pr No :</label>
                <input type="text" name="indentNo" value={header.fld_purnumber} readOnly/>

              </div>
              <div className="form-group">
                <label>PR Date :</label>
                <input type="text"
                value={header.fld_now ? new Date(header.fld_now).toISOString().split("T")[0] : ""} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Department :</label>
                <input type="text" name="type" value={header.fld_dept} readOnly />
              </div>
              <div className="form-group">
                <label>HOD :</label>
                <input type="text" name="branch" value={header.fld_hod} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Indent Ref :</label>
                <input type="text" value={header.fld_inref} readOnly/>
              </div>

              <div className="form-group">
                <label>Head Meterial:</label>
                <input type="text"value={header.fld_headmet} readOnly />
              </div>
            </div>
            
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Drawing Number</th>
                    <th>Description</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Due Date</th>
                    {showLifeDetail && (
                      <th style={{ textAlign: "center" }}>
                        Life Time
                      </th>
                    )}
                    <th>
                                                              <button
                                                                type="button"
                                                                onClick={() => setShowLifeDetail(!showLifeDetail)}
                                                                style={{
                                                                  background: "none",
                                                                  border: "none",
                                                                  cursor: "pointer",
                                                                }}
                                                              >
                                                                {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
                                                              </button>
                                                            </th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="9"><strong>Loading...</strong></td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.fld_itemcode}</td>
        <td>{item.fld_drawno}</td>
        <td>{item.fld_desc}</td>
        <td>{item.fld_uom}</td>
        <td>{item.fld_price}</td>
        <td>{item.fld_qty}</td>
        <td>{item.fld_duedate ? new Date(item.fld_duedate).toISOString().split("T")[0] : ""}</td>
         {showLifeDetail && (
 <td>{item.fld_lifetime}</td>  
                )}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9">No items</td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default StnViewSingle;
